import { Component, type ErrorInfo, type ReactNode } from 'react';

type ErrorBoundaryProps = { children: ReactNode };
type ErrorBoundaryState = { hasError: boolean };

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className="mx-auto max-w-2xl px-6 py-24 text-center">
          <h1 className="font-display text-3xl uppercase tracking-widest text-brand-redAccent">
            Something went wrong
          </h1>
          <p className="mt-4 text-white/80">
            Please refresh the page. If this keeps happening, try clearing your browser cache.
          </p>
          <a
            href="/"
            className="mt-8 inline-block rounded-full bg-brand-red px-6 py-3 font-heading text-sm font-bold uppercase tracking-wider text-white hover:bg-brand-redAccent"
          >
            Reload home
          </a>
        </section>
      );
    }
    return this.props.children;
  }
}
